// istanbul ignore file
import { useLayoutEffect, useRef } from 'react';

export const useEffectOnCloudChange = (cloudName: string, effectCallback: () => void, initRun = false) => {
  const cloudNameRef = useRef<string>();

  // useLayoutEffect used on purpose to perform effect callback BEFORE renders
  // so we can change urls easily or perform any other action
  // it won't hurt performance as it's called only ONCE after cloud changes
  useLayoutEffect(() => {
    if (cloudNameRef.current !== cloudName) {
      if ((!cloudNameRef.current && initRun) || cloudNameRef.current) {
        effectCallback();
      }

      cloudNameRef.current = cloudName;
    }
  }, [cloudName, effectCallback, initRun, cloudNameRef]);
};
